(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/init.js');

'use strict';

if (svs.eurojackpot.data.shouldUseReact) {
  svs.eurojackpot.logger.debug('Eurojackpot is running React component.');
} else {
  svs.numbergames.game_app.app.start({
    Router: svs.eurojackpot.Router,
    product: svs.numbergames.productMapping.CONSTANTS.EUROJACKPOT
  });
}

 })(window);